import { Outlet } from "react-router-dom";
import { Box, CssBaseline, AppBar, Toolbar, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";
import { VariantType, useSnackbar } from "notistack";
import Sidebar from "../../Layout/Sidebar";

interface LayoutProps {
    window?: Window;
}

export interface OutletcontextType {
    handleChangeTitle: (title: string, subTitle: string) => void;
    showSnackbar: (message: string, type?: VariantType) => void;
}

const GENOCRLayout = ({ window }: LayoutProps) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [headerText, setHeaderText] = React.useState({
        title: "",
        subTitle: "",
    });

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const handleChangeTitle = (title: string, subTitle: string) => {
        setHeaderText({
            title,
            subTitle,
        });
    };

    const showSnackbar = (message: string, type: VariantType = "error") => {
        enqueueSnackbar(message, {
            variant: type,
            action: (key) => <CloseIcon onClick={() => closeSnackbar(key)} />,
        });
    };

    const drawerWidth = 260;
    // const container = window !== undefined ? () => window().document.body : undefined;
    return (
        <Box>
            <CssBaseline />
            <Sidebar
                mobileOpen={mobileOpen}
                handleDrawerToggle={handleDrawerToggle}
                drawerWidth={drawerWidth}
            />
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    pt: "6px",
                    px: 3,
                    ml: { md: "auto" },
                    width: { md: `calc(100% - ${drawerWidth}px)` },
                }}
            >
                <Box sx={{ width: "100%" }}>
                    <Outlet context={{ handleChangeTitle, showSnackbar }} />
                </Box>
            </Box>
        </Box>
    );
};

export default GENOCRLayout;
